(() => {
  const money = (cents, currency='EUR') => new Intl.NumberFormat(document.documentElement.lang || 'de',{style:'currency',currency}).format(cents / 100);
  const initOffers = (root=document) => {
    root.querySelectorAll('[data-ms-offers]').forEach(offers => {
      if (offers.dataset.initialized) return;
      offers.dataset.initialized = 'true';
      const form = offers.querySelector('form');
      const tabs = [...offers.querySelectorAll('[data-offer-tab]')];
      const panels = [...offers.querySelectorAll('[data-offer-panel]')];
      const buy = form.querySelector('[data-offer-buy]');
      const setBuyDisabled = disabled => { if(buy) buy.disabled=disabled; };
      const choiceFor = mode => form.querySelector(`input[data-mode="${mode}"]:checked`);
      let mode = offers.dataset.defaultMode || 'club';
      const unavailableText = form.querySelector('[data-offer-error]').textContent;
      const targetVariant = new URL(location.href).searchParams.get('variant');
      if(targetVariant) { const choice=[...form.querySelectorAll('[data-target-variant]')].find(r=>r.dataset.targetVariant===targetVariant); if(choice) {choice.checked=true;mode='once';} }
      const kit = new URL(location.href).searchParams.get('kit');
      if(kit) { const choice=[...form.querySelectorAll('[data-kit]')].find(r=>r.dataset.kit===kit); if(choice) {choice.checked=true;mode='club';} }
      for (const m of ['once','club']) {if (!choiceFor(m)) {const first=form.querySelector(`input[data-mode="${m}"]`);if(first) first.checked=true;}}
      const sync = (updateUrl=false) => {
        const choice = choiceFor(mode);
        tabs.forEach(t=>{const selected=t.dataset.offerTab===mode;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1;});
        panels.forEach(p=>{p.hidden=p.dataset.offerPanel!==mode;});
        if(!choice) {setBuyDisabled(true);return;}
        const deposit=Number(choice.dataset.deposit), price=Number(choice.dataset.price);
        const ready=offers.dataset.ready==='true'&&choice.dataset.available==='true'&&choice.value&&deposit>=0&&price>deposit;
        form.querySelector('[data-offer-variant]').value=choice.value;
        form.querySelector('[data-offer-name]').value=choice.dataset.name;
        form.querySelector('[data-offer-deposit]').textContent=money(deposit,offers.dataset.currency);
        form.querySelector('[data-offer-balance]').textContent=money(price-deposit,offers.dataset.currency);
        // The CTA label sits inside the buy button, which is absent once the customer has reserved.
        const cta=form.querySelector('[data-offer-cta]');if(cta)cta.textContent=mode==='club'?offers.dataset.clubCta:offers.dataset.onceCta;
        form.querySelector('[data-offer-note]').textContent=mode==='club'?offers.dataset.clubNote:offers.dataset.onceNote;
        setBuyDisabled(!ready);
        form.querySelector('[data-offer-error]').textContent=unavailableText;
        form.querySelector('[data-offer-error]').hidden=Boolean(ready);
        if(updateUrl) {const u=new URL(location.href);if(mode==='club'){u.searchParams.set('kit',choice.dataset.kit);u.searchParams.delete('variant');}else{u.searchParams.set('variant',choice.dataset.targetVariant);u.searchParams.delete('kit');}history.replaceState({},'',u);}
      };
      tabs.forEach((tab,i)=>{
        tab.addEventListener('click',()=>{mode=tab.dataset.offerTab;sync(true);});
        tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const index=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+1)%tabs.length;tabs[index].focus({preventScroll:true});tabs[index].click();});
      });
      offers.querySelectorAll('.ms-offer-option').forEach(label=>label.addEventListener('click',e=>{
        const input=label.querySelector('input');if(e.target===input)return;e.preventDefault();input.checked=true;input.focus({preventScroll:true});input.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      form.addEventListener('change',e=>{if(e.target.matches('[data-offer-choice]'))sync(true);});
      // Free reservation: founder spot added while spots are left.
      const root=window.Shopify?.routes?.root||'/';
      const reserve=async()=>{
        // The server omits the reservation button after the customer's first RES2 order.
        // Keep the rest of the selector interactive, but never enter the cart flow without that button.
        if(!buy)return;
        buy.disabled=true;buy.setAttribute('aria-busy','true');
        const error=form.querySelector('[data-offer-error]');
        try{
          const properties={};
          new FormData(form).forEach((value,key)=>{const match=/^properties\[(.+)\]$/.exec(key);if(match)properties[match[1]]=value;});
          if(mode==='club') properties._ms_phonepad_terms='after-3-months';
          const variant=Number(form.querySelector('[data-offer-variant]').value);
          const cart=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}}).then(r=>r.json());
          const items=[];
          if(!cart.items.some(item=>item.variant_id===variant))items.push({id:variant,quantity:1,properties});
          const founder=Number(offers.dataset.founderVariant);
          const founderSpot=Number(offers.dataset.founderSpot);
          if(founder&&!cart.items.some(item=>item.variant_id===founder))items.push({id:founder,quantity:1,properties:{_ms_order_type:'founder',_ms_founder_spot:String(founderSpot)}});
          const add=list=>fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:list})});
          if(items.length){
            let response=await add(items);
            // The last founder spot may be gone in the meantime; the reservation itself still counts.
            if(!response.ok&&items.length>1&&items[1].id===founder)response=await add([items[0]]);
            if(!response.ok)throw new Error('cart');
          }
          location.assign(offers.dataset.cartUrl);
        }catch(_){
          buy.disabled=false;buy.removeAttribute('aria-busy');
          error.textContent=offers.dataset.errorMessage||error.textContent;error.hidden=false;
        }
      };
      form.addEventListener('submit',e=>{e.preventDefault();if(buy&&!buy.disabled)reserve();});
      sync();
      const params=new URL(location.href).searchParams;
      if(params.get('reserve')==='1'){
        const clean=new URL(location.href);clean.searchParams.delete('reserve');history.replaceState({},'',clean);
        if(offers.dataset.customer==='true'&&buy&&!buy.disabled&&offers===document.querySelector('[data-ms-offers]'))reserve();
      }
    });
  };
  const initSleepTest = (root=document) => {
    root.querySelectorAll('[data-sleep-test]').forEach(test=>{
      if(test.dataset.initialized)return;test.dataset.initialized='true';
      const questions=[...test.querySelectorAll('[data-sleep-question]')];
      const next=test.querySelector('[data-sleep-next]');
      const back=test.querySelector('[data-sleep-back]');
      let index=0;
      const show=(focus=false)=>{
        questions.forEach((q,i)=>q.hidden=i!==index);
        test.querySelector('[data-sleep-progress]').style.width=`${index/questions.length*100}%`;
        test.querySelector('[role="progressbar"]').setAttribute('aria-valuenow',String(index));
        test.querySelector('[data-sleep-count]').textContent=`${Math.min(index+1,questions.length)} / ${questions.length}`;
        back.hidden=index===0;next.disabled=!questions[index]?.querySelector('input:checked');
        if(index===questions.length){
          test.querySelector('[data-sleep-steps]').hidden=true;test.querySelector('[data-sleep-result]').hidden=false;
          const score=questions.reduce((sum,q)=>sum+Number(q.querySelector('input:checked')?.value||0),0);
          const level=score<4?'low':score<7?'medium':'high';
          test.querySelectorAll('[data-sleep-result-copy]').forEach(el=>el.hidden=el.dataset.sleepResultCopy!==level);
        }
        if(focus) (questions[index]?.querySelector('legend') || test.querySelector('[data-sleep-result]')).focus();
      };
      test.querySelector('form')?.addEventListener('submit',()=>{const url=new URL(location.href);url.searchParams.set('customer_posted','true');url.hash='SleepTest';test.querySelector('[name=return_to]').value=url.pathname+url.search+url.hash;});
      questions.forEach(q=>q.addEventListener('change',()=>{next.disabled=false;}));
      next.addEventListener('click',()=>{if(!questions[index].querySelector('input:checked'))return;index++;show(true);});
      back.addEventListener('click',()=>{index=Math.max(0,index-1);show(true);});
      test.querySelector('[data-copy-sleep-code]')?.addEventListener('click',async e=>{try{await navigator.clipboard.writeText(test.dataset.discountCode);e.currentTarget.textContent=test.dataset.copied;}catch{test.querySelector('[data-sleep-code]').focus();}});
      if(new URL(location.href).searchParams.get('customer_posted')==='true'&&location.hash.includes('Sleep')){
        test.querySelector('[data-sleep-steps]').hidden=true;test.querySelector('[data-sleep-result]').hidden=false;
        test.querySelectorAll('[data-sleep-result-copy]').forEach(el=>el.hidden=true);
        test.querySelector('[data-sleep-success]').hidden=false;test.querySelector('[data-sleep-signup]').hidden=true;
        if(!test.open) test.showModal();
      } else if(test.querySelector('[data-sleep-form-error]')) {
        test.querySelector('[data-sleep-steps]').hidden=true;test.querySelector('[data-sleep-result]').hidden=false;
        test.querySelectorAll('[data-sleep-result-copy]').forEach(el=>el.hidden=true);if(!test.open)test.showModal();
      } else show();
    });
  };
  // A failing offer selector must never keep the sleep test from working.
  const init = (root=document) => {for(const step of [initOffers,initSleepTest]){try{step(root);}catch(error){console.error(error);}}};
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
